module.exports = __webpack_public_path__ + "hibiskus_hibiscus_paper_mockup.png?87e2d2e489af1a89edb80c9975b2033f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/hibiskus_hibiscus_paper_mockup.png
// module id = 74
// module chunks = 0